import script from "./sharingDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./sharingDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./sharingDetailPage.vue?vue&type=style&index=0&id=6a29e99d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a29e99d"]])

export default __exports__